import React from 'react';
import { Outlet } from 'react-router-dom';

import Navbar from '../component/Navbar/Navbar';
import Footer from '../component/Footer';
import MobileTabBar from '../component/MobileTabBar';

export function Layout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      <MobileTabBar />
    </>
  );
}
